import * as React from 'react';
import * as Lockr from 'lockr';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { DebugState, DebugStore } from '../../stores/DebugStore';
import { HamburgerTab } from '../../constants/Enums';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { DebugActions } from '../../actions/DebugActions';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { UIHelper } from '../../utils/UIHelper';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { DesktopSelect } from '../DesktopSelect';
import { UICoreButton } from '../UICoreButton';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { i18n } from '../..';

import * as AppFileApiWrapper from '../../submodules/app-api/Filesystem/Wrapper';
import { appInfo } from '../../submodules/app-api/Information';
import { loadScript } from '../../submodules/utils/Helper';
import { registerLogHandler, BaseMessage } from '../../submodules/app-api/Communication';

export class DebugTab extends BaseHamburgerTab<DebugState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(DebugStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (!AppConfigurationStore.getState().inApp) {
            return (
                <div className={this.getCSSClass()}>
                    <div className="hamburger-tab-content scrollbar-wcf">
                        {this.header()}
                        <div className="hamburger-subheader">{this.state.id ? 'Session: ' + this.state.id : ''}</div>
                        <DesktopSelect
                            title={'Network requests'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleNetworkRequests},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleNetworkRequests}
                            ]}
                            toggle={'active'}
                            id="debug-nw-select"
                            value={this.state.network_requests}
                        />
                        <DesktopSelect
                            title={'APP API'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleAppMessage},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleAppMessage}
                            ]}
                            toggle={'active'}
                            disabled={!AppConfigurationStore.getState().inApp}
                            id="debug-am-select"
                            value={this.state.app_msg}
                        />
                        <DesktopSelect
                            title={'Actions'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleActions},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleActions}
                            ]}
                            toggle={'active'}
                            id="debug-actions-select"
                            value={this.state.actions}
                        />
                        <DesktopSelect
                            title={'Errors'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleLogErrors},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleLogErrors}
                            ]}
                            toggle={'active'}
                            id="debug-log-errors-select"
                            value={this.state.log_errors}
                        />
                        <DesktopSelect
                            title={'Log console output'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleConsoleLog},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleConsoleLog}
                            ]}
                            toggle={'active'}
                            disabled={this.state.log_to_console === 'true'}
                            id="debug-console-select"
                            value={this.state.console_log}
                        />
                        <DesktopSelect
                            title={'Log to browser console'}
                            options={[
                                {value: 'true', name: 'true', className: 'egr-select-option-noicon', callback: this.toggleLogToConsole},
                                {value: 'false', name: 'false', className: 'egr-select-option-noicon', callback: this.toggleLogToConsole}
                            ]}
                            toggle={'log_to_console'}
                            disabled={this.state.console_log === 'true'}
                            id="debug-log-to-console-select"
                            value={this.state.log_to_console}
                        />
                        <UICoreButton color="green" align="block" onClick={this.resetLockr} label="Reset all settings"/>
                        <UICoreButton color="green" align="block" onClick={this.deleteProjects} label="Delete all projects"/>
                        <UICoreButton color="green" align="block" onClick={this.showAdditionalInfo} label="Show additional information"/>
                        <UICoreButton color="green" align="block" onClick={this.showFileList} label="Show File List"/>
                        <UICoreButton color="green" align="block" onClick={this.closeEaiwsSession} label="Close EAIWS session"/>
                        <UICoreButton color="green" align="block" onClick={this.loadFirebugLite} label="Load Firebug Lite"/>
                        <UICoreButton color="green" align="block" onClick={this.registerAppApiLogHandler} label="Register App API log handler"/>
                    </div>
                </div>
            );
        }
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                <div className="sidebar-subheader">{this.state.id ? 'Session: ' + this.state.id : 'Log settings'}</div>
                <div className="long-button-group">
                    <div
                        className={'long-button short-border with-check' + (this.state.network_requests === 'true' ? ' checked' : '')}
                        onClick={this.toggleNetworkRequests}
                    >
                        Network requests
                    </div>
                    <div
                        className={
                            'long-button short-border with-check' +
                            (this.state.app_msg === 'true' ? ' checked' : '') +
                            (!AppConfigurationStore.getState().inApp ? ' not-available' : '')
                        }
                        onClick={this.toggleAppMessage}
                    >
                        APP API
                    </div>
                    <div
                        className={'long-button short-border with-check' + (this.state.actions === 'true' ? ' checked' : '')}
                        onClick={this.toggleActions}
                    >
                        Actions
                    </div>
                    <div
                        className={'long-button short-border with-check' + (this.state.log_errors === 'true' ? ' checked' : '')}
                        onClick={this.toggleLogErrors}
                    >
                        Errors
                    </div>
                    <div
                        className={
                            'long-button short-border with-check' +
                            (this.state.console_log === 'true' ? ' checked' : '') +
                            (this.state.log_to_console === 'true' ? ' not-available' : '')
                        }
                        onClick={this.toggleConsoleLog}
                    >
                        Log console output
                    </div>
                    <div
                        className={
                            'long-button short-border with-check' +
                            (this.state.log_to_console === 'true' ? ' checked' : '') +
                            (this.state.console_log === 'true' ? ' not-available' : '')
                        }
                        onClick={this.toggleLogToConsole}
                    >
                        Log to browser console
                    </div>
                </div>
                <div className="sidebar-subheader">Other options</div>
                <div className="long-button-group">
                    <div className="long-button" onClick={this.resetLockr}>Reset all settings</div>
                    <div className="long-button" onClick={this.deleteProjects}>Delete all projects</div>
                    <div className="long-button" onClick={this.showAdditionalInfo}>Show additional information</div>
                    <div className="long-button" onClick={this.showFileList}>Show File list</div>
                    <div className="long-button" onClick={this.closeEaiwsSession}>Close EAIWS session</div>
                    <div className="long-button" onClick={this.loadFirebugLite}>Load Firebug Lite</div>
                    <div className="long-button" onClick={this.registerAppApiLogHandler}>Register App API log handler</div>
                </div>
            </HamburgerContentWrapper>
        );
    }

    protected getLabel(): string {
        return 'Debug';
    }

    protected showFileList = (): void => {
        ViewSettingsActions.changeHamburger(HamburgerTab.FILE_LIST);
    };

    protected toggleNetworkRequests = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {network_requests: this.state.network_requests === 'true' ? 'false' : 'true'}));
    };

    protected toggleActions = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {actions: this.state.actions === 'true' ? 'false' : 'true'}));
    };

    protected toggleLogErrors = (): void => {
        DebugActions.updateSettings(jQuery.extend({}, this.state, {log_errors: this.state.log_errors === 'true' ? 'false' : 'true'}));
    };

    protected toggleConsoleLog = (): void => {
        if (this.state.log_to_console !== 'true') {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {console_log: this.state.console_log === 'true' ? 'false' : 'true'}));
        }
    };

    protected toggleLogToConsole = (): void => {
        if (this.state.console_log !== 'true') {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {log_to_console: this.state.log_to_console === 'true' ? 'false' : 'true'}));
        }
    };

    protected toggleAppMessage = (): void => {
        if (AppConfigurationStore.getState().inApp) {
            DebugActions.updateSettings(jQuery.extend({}, this.state, {app_msg: this.state.app_msg === 'true' ? 'false' : 'true'}));
        }
    };

    protected onChange = (): void => {
        this.setState(DebugStore.getState());
    };

    protected resetLockr = (): void => {
        UIHelper.ignoreReject(
            UIHelper.dialog('Delete all settings?', 'YES', 'NO').then((): void => {
                Lockr.flush();
            })
        );
    };

    protected deleteProjects = (): void => {
        UIHelper.ignoreReject(
            UIHelper.dialog('Delete all projects?', 'YES', 'NO').then((): void => {
                AppFileApiWrapper.list('/').then((files: Array<string>): void => {
                    files.map((path: string): void => {
                        AppFileApiWrapper.remove('/' + path);
                    });
                });
            })
        );
    };

    protected closeEaiwsSession(): void {
        UIHelper.ignoreReject(
            UIHelper.dialog('Close EAIWS Session?', 'YES', 'NO').then((): void => {
                GlobalHelper.eaiwsSession.close();
            })
        );
    }

    protected loadFirebugLite(): void {
        loadScript('https://getfirebug.com/firebug-lite.js#startOpened');
    }

    protected registerAppApiLogHandler(): void {
        registerLogHandler((msg: BaseMessage): void => {
            // tslint:disable-next-line:no-console
            console.log(msg);
        });
    }

    private showAdditionalInfo = async (): Promise<void> => {
        const content: string = [
            'Url: ' + window.location.href.toString(),
            'User-Agent: ' + window.navigator.userAgent.toString(),
            'Language: ' + window.navigator.language + ' (i18next: ' + i18n.language + ')',
            'EAIWS-Server: ' + GlobalHelper.eaiwsSession.baseUrl,
            'Mobile-Device: ' + (AppConfigurationStore.getState().mobileDevice ? 'yes' : 'no'),
            'Touch-Device: ' + (AppConfigurationStore.getState().touchDevice ? 'yes' : 'no'),
            'IDevice: ' + (AppConfigurationStore.getState().iDevice ? 'yes' : 'no'),
            'Android-Device: ' + (AppConfigurationStore.getState().os === 'AndroidOS' ? 'yes' : 'no'),
            'inApp: ' + (appInfo != null ? 'yes' : 'no'),
            'AR device: ' + ((appInfo != null && appInfo.ar_device) ? 'yes' : 'no'),
        ].join('\r\n\r\n');

        UIHelper.dialog(
            <textarea style={{width: '100%', height: '200px'}} value={content} />,
            'Close'
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/DebugTab.tsx